import { render, staticRenderFns } from "./indexList.vue?vue&type=template&id=e45b97b4&scoped=true&"
import script from "./indexList.vue?vue&type=script&lang=js&"
export * from "./indexList.vue?vue&type=script&lang=js&"
import style0 from "./indexList.vue?vue&type=style&index=0&id=e45b97b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45b97b4",
  null
  
)

export default component.exports